import { Combinator, Operator, RuleGroupInternalType, fromObject } from '@procureai/query-builder';
import JsonUrl from 'json-url';
import { useEffect } from 'react';

const jsonURL = JsonUrl('lzw');

export const encodeQueryRules = async (
  rules: {
    field: string;
    operator?: Operator;
    value: any;
  }[],
): Promise<string> => await jsonURL.compress(rules);

export const useEncodedQuery = (
  domain: string | undefined,
  encodedQuery: string | undefined,
  updateQuery: (rules: RuleGroupInternalType | undefined) => void,
): void => {
  useEffect(() => {
    if (encodedQuery) {
      (async () => {
        try {
          const rules = await jsonURL.decompress(encodedQuery);
          const result = fromObject({ rules, combinator: Combinator.AND });
          updateQuery(result);
        } catch (error) {
          updateQuery(undefined);
          console.log('cannot decode query');
        }
      })();
    }
  }, [domain, encodedQuery, updateQuery]);
};
